export default "## Nearby Tenancy\n\nThis score shows how much more likely this brand is to choose locations that are located near the Nearby Tenants above.\n";